import { render, staticRenderFns } from "./item-header.vue?vue&type=template&id=e5a08b90&"
import script from "./item-header.vue?vue&type=script&lang=js&"
export * from "./item-header.vue?vue&type=script&lang=js&"
import style0 from "./item-header.vue?vue&type=style&index=0&id=e5a08b90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports